/* eslint-disable */

/** unique or primary key constraints on table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistoryConstraint {
  /** unique or primary key constraint on columns "material_attribute_history_id" */
  MaterialAttributeHistoryPkey = 'material_attribute_history_pkey'
}

/** select columns of table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistorySelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistoryUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

